import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/useAuth.jsx';
import { ResidentProvider } from './lib/useResident.jsx';
import { DeviceProvider } from './lib/useDevice.jsx';
import { IndividualUserProvider } from './lib/useIndividualUser.jsx';
import { CurrentContextProvider } from './lib/useCurrentContext.jsx';
import App from './App.jsx';
import './styles/global.css';

// Provider tree, outer-to-inner:
//
//   AuthProvider              — Firebase Auth state (admin + individual)
//   ResidentProvider          — community resident login-code session
//   DeviceProvider            — Hexnode-provisioned tablet session
//   IndividualUserProvider    — /brain_health/users/{uid} record for
//                               authenticated individual subscribers.
//                               Must be inside AuthProvider since it
//                               reads from useAuth().
//   CurrentContextProvider    — adapter that reads all three identity
//                               sources and exposes a unified surface.
//                               Must be innermost identity wrapper,
//                               so it can read all the providers above.
//
// The three identity providers are independent — a browser could in
// principle have both an admin Firebase session and a resident
// localStorage session at the same time without conflict. The
// CurrentContextProvider resolves which one "wins" for the purpose
// of game/dashboard rendering, in this priority order:
//
//   DEVICE > COMMUNITY_RESIDENT > INDIVIDUAL_USER > NONE
//
// See useCurrentContext.jsx for the rationale on that order.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ResidentProvider>
          <DeviceProvider>
            <IndividualUserProvider>
              <CurrentContextProvider>
                <App />
              </CurrentContextProvider>
            </IndividualUserProvider>
          </DeviceProvider>
        </ResidentProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
